<template>
    <div class="mainBox">
        <div class="boxTop">
            <h5>区县诚信指数排行</h5>
            <div class="sortBtn" @click="changeSort">
                <span>排序</span>
                <div>
                    <img src="../../../assets/image/ic_px.png" v-show="isUpSort">
                    <img src="../../../assets/image/ic_px_dx.png" v-show="!isUpSort">
                </div>
            </div>
        </div>
        <ul class="rankingList">
            <li v-for="(item, index) in areaListData" :key="index">
                <span>{{(1*index+1)+"、"}}</span>
                <p>{{item.regionName}}</p>
                <span>{{item.score+"分"}}</span>
            </li>
        </ul>
        <router-link class="toMore" to="/integrity/districtRanking">
            <span>查看更多排名</span>
            <img src="../../../assets/image/t-right.png">
        </router-link>

    </div>
</template>

<script>
    export default {
        name: 'CountyRanking',
        props: ['areaListData'],
        data () {
            return {
                isUpSort: true,
                sortData: [],
                upData: [
                    {
                        sortId: 1,
                        enterpriseName: '云上四季连锁酒店（昆明新闻路大商汇誉城酒誉城酒店',
                        sortScore: '9.8'
                    }, {
                        sortId: 2,
                        enterpriseName: '丽江春秋假日五星酒店',
                        sortScore: '9.8'
                    }, {
                        sortId: 3,
                        enterpriseName: '昆明索菲亚特大酒店',
                        sortScore: '9.8'
                    },
                    {
                        sortId: 4,
                        enterpriseName: '卡密主题酒店',
                        sortScore: '9.8'
                    },
                    {
                        sortId: 5,
                        enterpriseName: '帝贝特酒店（昆明世纪城店）',
                        sortScore: '9.8'
                    }

                ],
                downData: [
                    {
                        sortId: 5,
                        enterpriseName: '云上四季连锁酒店（昆明新闻路大商汇誉城酒誉城酒店',
                        sortScore: '9.8'
                    }, {
                        sortId: 4,
                        enterpriseName: '丽江春秋假日五星酒店',
                        sortScore: '9.8'
                    }, {
                        sortId: 3,
                        enterpriseName: '昆明索菲亚特大酒店',
                        sortScore: '9.8'
                    },
                    {
                        sortId: 2,
                        enterpriseName: '卡密主题酒店',
                        sortScore: '9.8'
                    },
                    {
                        sortId: 1,
                        enterpriseName: '帝贝特酒店（昆明世纪城店）',
                        sortScore: '9.8'
                    }

                ]
            }
        },
        mounted () {
            this.sortData = this.upData;
        },
        methods: {
            changeSort () {
                this.isUpSort = !this.isUpSort;
                this.$emit('changeGetAreaListData')
            }
        }
    }
</script>

<style lang="less" scoped>
    .mainBox{
        width:100%;
        background: #fff;
        padding: 24px 16px;
    }

    .boxTop{
        margin-bottom: 22px;
    }

    .boxTop::after{
        content: "";
        display: block;
        clear: both;
    }

    .boxTop>h5{
        font-size: 14px;
        font-weight: bold;
        float: left;
    }

    .boxTop>.sortBtn{
        float: right;
    }

    .sortBtn{
        text-align: center;
        line-height: 12px;
    }

    .sortBtn::after{
        content: "";
        display: block;
        clear: both;
    }

    .sortBtn>span{
        margin-right: 3px;
        float: left;
    }

    .sortBtn>div{
        width: 14px;
        height: 12px;
        background-color: #000;
        float: left;
    }

    .sortBtn>div>img{
        width: 100%;
        height: 100%;
    }

    .rankingList{
        margin-bottom: 12px;
    }

    .rankingList>li{
        color: #666;
    }

    .rankingList>li::after{
        content: "";
        display: block;
        clear: both;
    }

    .rankingList>li>span:first-child{
        line-height: 35px;
        float: left;
    }

    .rankingList>li>span:last-child{
        line-height: 35px;
        float: right;
    }

    .rankingList>li>p{
        max-width: 270px;
        line-height: 35px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        float: left;
    }

    .toMore{
        width: 100%;
        margin: 0 auto;
        text-align: center;
        color: #9B9B9B;
        display: flex;
        justify-content: center;
    }

    .toMore::after{
        content: "";
        display: block;
        clear: both;
    }

    .toMore>span{
        float: left;
    }

    .toMore>img{
        width: 8px;
        height: 8px;
        margin-left: 2px;
        float: left;
        position: relative;
        top: 3px;
    }
</style>
